<template>
  <section class="contactdetails">
    <div class="grid grid-rows">
      <v-header title="Contact" />
      <div class="contactdetails__phoneNumbers p-6" v-html="contactInfo.PhoneNumbers" />
    </div>
  </section>
</template>
<script>
import VHeader from '@/components/shared/Header.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'ContactDetails',
  components: {
    VHeader
  },
  setup() {
    const store = useStore();

    const contactInfo = computed(() => store.getters['contact/getContactInfo']);
    store.dispatch('contact/fetchContactInfo');

    return {
      contactInfo
    };
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.contactdetails {
  &__phoneNumbers {
    :deep(td, th) {
      padding-right: 24px;
      padding-bottom: 16px;
    }
  }
}
</style>
